class GoogleTagManager {

    static EVENT_PAGEVIEW = 'page_view';
    static EVENT_REMOVE_FROM_CART = 'remove_from_cart';

    srcUrl = 'https://www.googletagmanager.com/gtag/js?id=';
    srcId = 'UA-1590792-28';
    srcScriptId = 'gtm-script';
    gTagScriptId = 'gtag-script';

    constructor() {}

    async insertGTMScript() {
        let scriptObject = top.document.createElement('script');
        scriptObject.setAttribute('type', 'text/javascript');
        scriptObject.setAttribute('language', 'javascript');
        scriptObject.setAttribute('async', '');
        scriptObject.setAttribute('src', this.srcUrl + this.srcId);
        scriptObject.setAttribute('id', this.srcScriptId);

        let body = top.document.body || top.document.getElementsByTagName('body')[0];
        body.appendChild(scriptObject);
    }

    insertGTAGScript() {
        let scriptObject = top.document.createElement('script');
        scriptObject.setAttribute('id', this.gTagScriptId);

        let scriptCodes = "";
        scriptCodes += "window.dataLayer = window.dataLayer || []; \n";
        scriptCodes += "function gtag(){dataLayer.push(arguments);} \n";
        scriptCodes += "gtag('js', new Date()); \n";
        scriptCodes += "gtag('config', '" + this.srcId + "'); \n";

        let inlineScript = top.document.createTextNode(scriptCodes);
        scriptObject.appendChild(inlineScript);

        let body = top.document.body || top.document.getElementsByTagName('body')[0];
        body.appendChild(scriptObject);
    }

    execute() {
        let vm = this;
        this.insertGTMScript().then(() => {
            let loadedScript = top.document.querySelector("#" + vm.srcScriptId);
            loadedScript.addEventListener('load', function () {
                vm.insertGTAGScript();
            });
        });
    }

    static triggerEvent(eventType, absoluteUrl, pagePath, pageTitle) {
        if(typeof gtag === 'function'){
            top.window.gtag('event', eventType, {
                page_location: absoluteUrl,
                page_path: pagePath,
                page_title: pageTitle
            });
        }
    }

    static triggerActionEvent(eventType, data){
        if(typeof gtag === 'function'){
            top.window.gtag('event', eventType, data);
        }
    }

    static trackClickEvent(eventName, path, title){
        if(typeof gtag === 'function'){
            top.window.gtag('event', eventName, {
                page_path: path,
                page_title: title
            });
        }
    }
    
    static trackOutboundClickEvent(eventName, path, title, url) {
        if(typeof gtag === 'function'){
            top.window.gtag('event', eventName, {
                page_path: path,
                page_title: title,
                page_url: url
            });
        }
    }
}

export default GoogleTagManager;